import { useWizard } from 'react-use-wizard';

export function ProgressBar() {
  const { activeStep, stepCount } = useWizard();

  // Don't show progress on welcome screen
  if (activeStep === 0) return null;

  // Adjust for welcome step (5 actual form steps)
  const currentStep = activeStep;
  const totalSteps = stepCount - 1; // Exclude welcome
  const progress = ((currentStep) / totalSteps) * 100;

  return (
    <div className="fixed top-0 left-0 right-0 z-50">
      <div className="h-1 bg-gray-200">
        <div
          className="h-full bg-blue-600 transition-all duration-500 ease-out"
          style={{ width: `${progress}%` }}
        />
      </div>
    </div>
  );
}
